import React from 'react';

import i18n from 'asset/translation';
import { Description, Disclaimer, Loading } from 'adapter/in/common/components/AnalysisAiDescriptionView/style';

export {
    AiDescriptionContainer,
    AI_DESCRIPTION_LINE_HEIGHT,
    AI_DESCRIPTION_GAP,
} from 'adapter/in/common/components/AnalysisAiDescriptionView/style';

type Props = {
    text?: string;
    isLoading?: boolean;
    descriptionTestId: string;
    loadingTestId: string;
    descriptionMaxLines?: number;
    disclaimerRef?: React.Ref<HTMLParagraphElement>;
};

const AnalysisAiDescriptionView = ({ text, isLoading, descriptionTestId, loadingTestId, descriptionMaxLines, disclaimerRef }: Props) => {
    if (text) {
        return (
            <>
                <Description data-testid={descriptionTestId} $maxLines={descriptionMaxLines}>
                    {text}
                </Description>
                <Disclaimer ref={disclaimerRef} data-testid='ai-description-disclaimer'>
                    {i18n.t('advancedAnalytics.globalSettings.aiDescription.disclaimer')}
                </Disclaimer>
            </>
        );
    }

    if (isLoading) {
        return <Loading data-testid={loadingTestId}>{i18n.t('advancedAnalytics.globalSettings.aiDescription.loading')}</Loading>;
    }

    return null;
};

export default AnalysisAiDescriptionView;
